import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FreshAuthService } from '../fresh-auth.services';
import { environment as ENV } from '../../../environments/environment';
import { environment } from '../../../environments/environment.ubi';
import { UntypedFormControl, FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../../admin/admin.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AddCustomerService } from '../../admin/add-customer.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

import { Observable } from 'rxjs';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';


@Component({
  selector: 'wl-view-failure-page',
  providers: [AddCustomerService, AdminService],
  templateUrl: './view-failure-page.component.html',
  styleUrls: ['./view-failure-page.component.scss'],
})
export class ViewFailurePageComponent implements OnInit {
  noUserFound: string;
  searchHolder: string;
  showSelectedDate: boolean;
  currentDate: String;
  selectedDate: any;
  allUsers: any;
  loading: boolean;
  limit: number = 10;
  offset: number = 0;
  totalCount: any;
  search = new UntypedFormControl();
  pageId = 1;
  page: number = 1;
  filterTableDate = new Date();
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  kccNewUat: string = environment.kccNewUat;
  @ViewChild('date1') firstDate: ElementRef;
  totalPage: number = 1;
  failureMapping = {
    cfd_status: 'status',
    generate_aadhar: 'aadhar_response',
    kcc_account_fetched: 'overall_status',
    land_bre_status: 'land_bre_status',
    land_geomapping: 'response',
    verify_aadhar: 'aadhar_response',
    cic: {
      cibil: 'npaStatus',
      experian: 'npaStatus',
    },
  };
  iscredCount: any;
  showOrHide: boolean;
  
  display: boolean;
  roleId: number;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showFailureDataTable: boolean = true;
  filter: string = "";

  constructor(
    private freshAuthService: FreshAuthService,
    private customer: FreshAuthService,
    private snackbar: MatSnackBar,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private advancedFilterService: AdvancedFilterService
  ) {
    
    this.iscredCount = ENV.creditScoreSetting.credCount;

    this.searchHolder = 'Search Applicant by Name';
 
    this.display = false;
  }

  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.pageId = 1;
    this.page = 1;
    this.loading = true;
    this.customer.getLoanFailureUsers(value, 1, 0, 10).subscribe(
      (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData || [];
          this.getFailureReason();
          this.totalCount = res.result.count || 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      (err) => {
        this.totalCount = 0;
        this.totalPage = 0;
        this.loading = false;
        throw err;
      }
    );
  }

  ngOnInit() {
    this.roleId = +this.freshAuthService.getRoleId();
    if (this.isCoLogin()) {
      this.showFailureDataTable = false;
    }

    sessionStorage.removeItem('filterDateFailureStart');
    sessionStorage.removeItem('filterDateFailureEnd');
    this.maxDate = this.freshAuthService.getCurrentMonth();
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    !this.isCoLogin() && this.getData();

  }

  getData() {
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    this.freshAuthService
      .loan_failure_page(
        admin_id,
        1,
        '',
        0,
        10,
        'loan_failure_page',
        branch_code,
        ro_code,
        zonal_code
      )
      .subscribe(
        (res) => {
          console.log(res, 'hello');
          this.loading = false;
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);

          this.allUsers = res.resultData ? res.resultData : [];

          this.getFailureReason();

          console.log(this.allUsers.map((user) => user.newFailureArray));
        },
        (err) => {
          this.loading = false;
          throw err;
        }
      );
  }

  getFailureReason() {
    this.allUsers = this.allUsers.map((user) => {
      user.modified_date = moment(new Date(user.modified_date)).format('DD/MM/YYYY');
      // debugger
      console.log('al user', this.allUsers);
      let newFailureArray = [];
      let failureArray = [];
      let journeyTracker = user.trackerObj.journey_tracker;

      let keysToCheckWithAadhaar = [
        'kcc_account_fetched',
        'generate_aadhar',
        'verify_aadhar',
        'cfd_status',
        'experian',
        'cibil',
        'cicreport',
        'land_bre_status',
        'land_geomapping',
      ];
      let keysToCheckWithoutAadhaar = [
        'cfd_status',
        'experian',
        'cibil',
        'cicreport',
        'land_bre_status',
        'land_geomapping',
      ];
      // let keysToCheck = this.getKeysToCheck(user.appStatus)
      let keysToCheck = keysToCheckWithAadhaar;
      let falseValues = [null, 'Nill', 'nill', 'null', 'Nil', 'nil'];
      if(user.ubi_reference_no && !falseValues.includes(user.ubi_reference_no)){
        keysToCheck = keysToCheckWithoutAadhaar
      }
      if(keysToCheck && keysToCheck.length){
        for (let key of keysToCheck) {
          if (journeyTracker.hasOwnProperty(key)) {
            let newFailureObj = this.getFailureResults(key, journeyTracker[key]);
            newFailureArray.push(...newFailureObj);
            let failureObj = this.getFailureStatus(key, journeyTracker[key]);
            failureArray.push(failureObj);
          }
        }
      }else{
        return user
      }


      let mapObj = {
        ...user,
        ...(failureArray.length > 0 && { failureArray: failureArray.filter((obj) => !obj.status) }),
        newFailureArray: newFailureArray,
      };
      return mapObj;
    });
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, 'loan_failure_page').subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        this.allUsers = res && res.result && res.result.resultData ? res.result.resultData : [];
        this.getFailureReason();
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);

      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getFailureStatus(key, object) {
    const res: string | object[] = object[this.failureMapping[key]];
    if (typeof res == 'string') {
      if (res && res.toLowerCase() == 'failure') {
        return { value: key, status: false, date: new Date(object['date']) };
      } else return { value: key, status: true, date: new Date(object['date']) };
    } else if (typeof res == 'object') {
      for (const sKey in res) {
        if (sKey == 'cibil' || sKey == 'experian') {
          if (
            object &&
            object[0] &&
            object[0][sKey] &&
            object[0][sKey].toLowerCase() == 'failure'
          ) {
            return { value: sKey, status: false, date: new Date(object['date']) };
          } else {
            return { value: sKey, status: true, date: new Date(object['date']) };
          }
        } else return { value: sKey, status: true, date: new Date(object['date']) };
      }
    } else return { value: key, status: true, date: new Date(object['date']) };
  }

  getFailureResults(key, object): any {
    // debugger
    let returnedArr = [];
    let failures = ["failure","Failure","FAILURE"]
    switch (key) {
      case 'cic':
        if (typeof object == 'object') {
          let sReturnedArr = [];
          for (key in object[0]) sReturnedArr.push(...this.getFailureResults(key, object[0][key]));
          return sReturnedArr;
        }
      case 'experian':
      case 'cibil':
        if ((object.npaStatus && object.npaStatus == true) || (object.npaStatus && object.npaStatus == 'true')) {
          return [
            {
              // message: 'NPA exists',
              message:'Default in CIC',
              date: moment(new Date(object.date)).format('DD/MM/YYYY'),
            },
          ];
        }
        break;
      case 'cicreport':
        if (
          (object.cibil &&
          object.cibil.npaStatus == true) ||
          (object.experian &&
          object.experian.npaStatus == true)
        ) {
          return [
            {
              // message: 'NPA exists',
              message:'Default in CIC',
              date: moment(new Date(object.cibil && object.cibil.npaStatus?object.cibil.date:object.experian && object.experian.npaStatus?object.experian.npaStatus:"")).format('DD/MM/YYYY'),
            },
          ];
        }
      case 'generate_aadhar':
        if (
          object.aadhar_details_number_mismatch == true )
          returnedArr.push({
            // message: 'Invalid Aadhaar No. Entry',
            message:'Profile Name Mismatch (CBS - Aadhaar)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          })
          else if(failures.includes(object.aadhar_response))
          returnedArr.push(
            {message:' Technical Error (Aadhaar OTP generation failure)',
            date:moment(new Date(object.date)).format('DD/MM/YYYY')
            }
          )
        break;

      case 'verify_aadhar':
        if (failures.includes(object.agestatus))
          returnedArr.push({
            message: 'Profile age mismatch (Age < 18 years)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        else if (failures.includes(object.name_match))
          returnedArr.push({
            message: ' Profile Name Mismatch (CBS - Aadhaar)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        else if(failures.includes(object.aadhar_response))
        returnedArr.push({
          message: 'Aadhaar verification failure.',
          date: moment(new Date(object.date)).format('DD/MM/YYYY'),
        });

        break;

      case 'kcc_account_fetched':
        // if (object.sba_status == true)
        //   returnedArr.push({
        //     message: 'Not an existing bank customer',
        //     date: moment(new Date(object.date)).format('DD/MM/YYYY'),
        //   })
        // else  //commented as sba_status is true by default
        if (failures.includes(object.overall_status))
        returnedArr.push({
          message: 'KCC loan already exists',
          date: moment(new Date(object.date)).format('DD/MM/YYYY'),
        })
        break;

      case 'land_bre_status':
        if (object.isCourtCase == true || object.isCourtCase == 'true')
          returnedArr.push({
            // message: 'Land under litigation',
            message:'Other Bank Charge (Court/Litigation - Yes)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        else if (object.isIrrigated == false || object.isIrrigated == 'false')
          returnedArr.push({
            message: 'Land is unirrigated',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        else if (object.profile_match == false || object.profile_match == 'false' || failures.includes(object.profile_match))
          returnedArr.push({
            // message: 'Name as per state land recor and CBS do not match',
            message:'Profile Name Mismatch (CBS - Land details)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        else if (object.isMortgage == true || object.isMortgage == 'true')
          returnedArr.push({
            // message: 'Active charge found',
            message:'Other Bank Charge (From MPLRS - Mortagage - Yes)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });

        else if (object.ownershare == true || object.ownershare == 'true')
          returnedArr.push({
            // message: 'Multiple owners exist',
            message:'Land has Multiple Owners',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        else if(failures.includes(object.land_bre_status))
          returnedArr.push({
            message: 'BRE failure (Land verification failure.)',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        break;

      case 'land_geomapping':
        if (object && object.request && object.request.toLowerCase() == 'failure')
          returnedArr.push({
            message: 'Satellite data Not found',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        if (object && object.response && object.response.toLowerCase() == 'failure')
          returnedArr.push({
            message: 'Satellite data Not found',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        break;

      case 'cfd_status':
        if (object && object.status && object.status.toLowerCase() == 'failure')
          returnedArr.push({
            message: 'CFR record found',
            date: moment(new Date(object.date)).format('DD/MM/YYYY'),
          });
        break;

      default:
        return [
          {
            message: '',
            date: moment(new Date()).format('DD/MM/YYYY'),
          },
        ];
    }
    return returnedArr;
  }

  getKeysToCheck(appStatus) {
    let keysToCheck=[];
    switch (appStatus) {
      case "loanRefNoGenerated":
        keysToCheck = [
            'cfd_status',
            'experian',
            'cibil',
            'land_bre_status',
            'land_geomapping',
          ];
        return keysToCheck;
      case "satsureReportGenerated":
        keysToCheck = [
            'land_geomapping',
          ];
        return keysToCheck;
      case "cropPatternSubmitted":
        return keysToCheck;
      case "loanAmountCalculated":
      case "docsExecutedRequest":
        return keysToCheck;
      case "docsExecuted":
        return keysToCheck;
      case "LAND_RECORD":
        return keysToCheck;
      case "NESL":
        return keysToCheck;
      case "NESLREQUEST":
        return keysToCheck;
      default:
        return keysToCheck;

    }
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateFailureStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateFailureEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getFailureUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            }
          } else {
            // this.allUsers = this.getEmptyArray()
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }


  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateFailureStart');
    sessionStorage.removeItem('filterDateFailureEnd');
    sessionStorage.removeItem('filterDateSanction');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }
  ngOnDestroy() {
    console.log('foo destroy');
    sessionStorage.removeItem('filterDateFailureStart');
    sessionStorage.removeItem('filterDateFailureEnd');
  }

  isCoLogin() {
    if (this.roleId === 1) {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showFailureDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    try {
      this.freshAuthService.getFailures(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          this.allUsers = response && response.resultData ? response.resultData : [];
          if (!this.allUsers.length) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.getFailureReason();
          }
          this.totalCount = response && response.count ? response.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }
}
interface TrackerObj {
  cfd_status: {
      date: number | string,
      status: string
  },
  cic: [
      {
          cibil: {
              date: string | number,
              generated: string | any,
              npaStatus: string | any
          },
          experian: {
              date: string | number,
              generated: string | any,
              npaStatus: string
          }
      }
  ],
  generate_aadhar: {
      aadhar_details_number_mismatch: boolean,
      aadhar_response: string,
      date: string | number 
  },
  kcc_account_fetched: {
      cca_status: boolean,
      date: string | number,
      overall_status: string,
      sba_status: boolean
  },
  land_bre_status: {
      date: number | string,
      final_status: string,
      isCourtCase: boolean,
      isIrrigated: boolean,
      isMortgage: boolean,
      land_bre_status: string,
      ownershare: string,
      profile_match: string
  },
  land_geomapping: {
      date: number | string,
      request: string,
      response: string
  },
  verify_aadhar: {
      aadhar_response: string,
      agestatus: string,
      date: string,
      name_match: string
  }
}